import { MessagingChannel } from '../channel';
import { CHAT_STATUS, IChat, IChatNote } from '../chat';
import { QueryStrBool } from './_includes';
import { Media as _Media } from './chats/media';
import { HttpController } from '../chats';

/**
 * @deprecated Use Chats.CountQuery
 */
export type ChatsCountQuery = Chats.CountQuery;

/**
 * @deprecated Use Chats.CountQuery
 */
export type ChatsCountResponse = Chats.CountResponse;

/**
 * @deprecated Use Chats.ListQuery
 */
export type ChatsGetQuery = Chats.ListQuery<false>;

/**
 * @deprecated Use Chats.ListResponse
 */
export type ChatsGetResponse = Chats.ListResponse<true>;

/**
 * @deprecated
 */
export type ChatUpdateResponse = IChat<true>;

/**
 * @deprecated Use Chats.AssignBody
 */
export type ChatAssignBody = Chats.AssignBody;

/**
 * @deprecated Use Chats.AssignResponse
 */
export type ChatAssignResponse = Chats.AssignResponse;

/**
 * @deprecated Use Chats.ResolveBody
 */
export type ChatResolveBody = Chats.ResolveBody;

/**
 * @deprecated No response
 */
export type ChatResolveResponse = void;

/**
 * @deprecated Use Chats.BulkResolveBody
 */
export type ChatsBulkResolveBody = Chats.BulkResolveBody;

/**
 * @deprecated No response
 */
export type ChatsBulkResolveResponse = void;

/**
 * @deprecated Use Chats.GetResponse
 */
export type ChatGetResponse = Chats.GetResponse;

/**
 * @deprecated Use Chats.CreateBody
 */
export type ChatCreateBody = Chats.CreateBody;

/**
 * @deprecated Use Chats.CreateResponse
 */
export type ChatCreateResponse = Chats.CreateResponse;

/**
 * @deprecated Use Chats.PatchBody
 */
export type ChatPatchBody = Chats.PatchBody;

/**
 * @deprecated Use Chats.PatchResponse
 */
export type ChatPatchResponse = Chats.PatchResponse;

/**
 * @deprecated Use Chats.SubscribeBody
 */
export type ChatSubscribeBody = Chats.SubscribeBody;

/**
 * @deprecated Use Chats.SetReadBody
 */
export type ChatSetReadBody = Chats.SetReadBody;

/**
 * @deprecated Use Chats.SetReadResponse
 */
export type ChatSetReadResponse = Chats.SetReadResponse;

/**
 * @deprecated Use Chats.ListUnsubscribedBody
 */
export type ChatsGetUnsubscribedBody = Chats.ListUnsubscribedBody;

/**
 * @deprecated Use Chats.ListUnsubscribedResponse
 */
export type ChatsGetUnsubscribedResponse = Chats.ListUnsubscribedResponse;

/**
 * @deprecated Use Chats.AddNoteBody
 */
export type ChatNoteBody = Chats.AddNoteBody;

/**
 * @deprecated Use Chats.AddNoteResponse
 */
export type ChatAddNoteResponse = Chats.AddNoteResponse;

/**
 * @deprecated Use Chats.ListNotesResponse
 */
export type ChatGetNotesResponse = Chats.ListNotesResponse;

/**
 * @deprecated Use Chats.PatchNoteResponse
 */
export type ChatEditNoteResponse = Chats.PatchNoteResponse;

/**
 * @deprecated No response
 */
export type ChatDeleteNoteResponse = void;

/**
 * @deprecated Use Chats.RunBotBody
 */
export type ChatRunBotBody = Chats.RunBotBody;

export namespace Chats {

    export const BOT_AGENT_FILTER_UID = 'WITH_BOT' as const;

    export const NOT_ASSIGNED_DEPARTMENT_FILTER_ID = 'NOT_ASSIGNED' as const;

    /**
     * Maximum number of chats to get in one multiple request
     */
    export const GET_MULTIPLE_ITEMS_MAX = 1000;

    export type GetMultipleQuery = {
        ids: string[];
    };

    export type GetMultipleResponse<IsJSON extends boolean = true> = IChat<IsJSON>[];

    export type GetResponse<IsJSON extends boolean = true> = IChat<IsJSON>;

    export type CreateBody = {
        channel: MessagingChannel;
        accountId: string;
        channelContactId: string;
    };

    export type CreateResponse<IsJSON extends boolean = true> = GetResponse<IsJSON>;

    export type ListQuery<IsServer extends boolean = false> = VisibilityFilters & {
        limit?: IsServer extends true ? string : number;
        skip?: IsServer extends true ? string : number;
        /** Only chats for this department */
        department?: string;
        /** Only chats with this agent UID */
        agent?: string;
        /** Search substring in chat title or phone number */
        search?: string;
        /** Only chats with specified status name */
        status?: STATUS_NAME;
        /** Return first chats where current authenticated user UID === chat.agent.uid */
        ownFirst?: IsServer extends true ? QueryStrBool : boolean;
        /** Return first chats where current authenticated user UID === chat.sendingBulkAgent */
        ownBulkFirst?: IsServer extends true ? QueryStrBool : boolean;
        channelName?: MessagingChannel;
        channelAccountId?: string;
        /**
         * Show only chats that include any of specified labels
         */
        labels?: string[];
    };

    export type ListResponse<IsJSON extends boolean = true> = {
        chats: Array<IChat<IsJSON>>;
        totalFound: number;
    };

    export type ListUnsubscribedBody = {
        /** Limit return items. Default: 1000 */
        limit?: number;
        /** Skip items. Default: 0 */
        skip?: number;
        /** Match by phone numbers. Max: 1000 numbers a once */
        filterPhoneNumbers?: string[];
    };

    export type ListUnsubscribedResponse<IsJSON extends boolean = true> = {
        chats: Array<
            Pick<IChat<IsJSON>, '_id' | 'title' | 'clientPhoneE164' | 'unsubscribed'>
        >;
        totalFound: number;
    };

    export type AssignBody = {
        agentUid?: string | null;
        departmentId?: string | null;
    };

    export type AssignResponse<IsJSON extends boolean = true> = GetResponse<IsJSON>;

    export type CountQuery<IsServer extends boolean = false> = VisibilityFilters & {
        beforeTimestamp?: IsServer extends true ? string : number;
        afterTimestamp?: IsServer extends true ? string : number;
    };

    export type CountResponse = {
        status: StatusCount;
        all: number;
        waiting: number;
    };

    export type ResolveBody = {
        notifyClient?: boolean;
        crmData?: {
            [x: string]: any;
        };
        runBot?: RunBotParams;
    };

    export type BulkResolveBody = {
        beforeTimestamp: number;
        status?: CHAT_STATUS;
    };

    export type PatchBody = Partial<
        Pick<
            IChat<true>,
            'unreadCount' | 'blockedChat'
        >
    >;

    export type PatchResponse<IsJSON extends boolean = true> = GetResponse<IsJSON>;

    export type SubscribeBody = {
        subscribe: boolean;
    };

    export type SetReadBody = { messages: string[]; all?: undefined } | { all: true; messages?: undefined };

    export type SetReadResponse<IsJSON extends boolean = true> = GetResponse<IsJSON>;

    export type RunBotBody = RunBotParams;

    export type AddNoteBody = {
        text: string;
    };

    export type AddNoteResponse<IsJSON extends boolean = true> = IChatNote<IsJSON>;

    export type ListNotesResponse<IsJSON extends boolean = true> = IChatNote<IsJSON>[];

    export type PatchNoteBody = AddNoteBody;

    export type PatchNoteResponse<IsJSON extends boolean = true> = IChatNote<IsJSON>;

    type VisibilityFilters = {
        departmentConditionFilter?: DepartmentConditionFilter;
    };

    type STATUS_NAME = keyof typeof CHAT_STATUS;

    export type StatusCount = {
        [key in STATUS_NAME]?: number
    };

    type RunBotParams = {
        /** Node name to start bot from. If not specified then used default bot start node */
        nodeName?: string;
        /** Text to send to bot. If not specified then used empty string */
        text?: string;
    };

    export enum DepartmentConditionFilter {
        /**
         * Only chats with department assigned to current user department
         */
        only_own = 'only_own',
        /**
         * Only chats with department assigned to current user department or unassigned (no department and no agent)
         */
        own_and_unassigned = 'own_and_unassigned',
    }

    export import Media = _Media;

    export namespace Labels {

        export type PostRequest = HttpController.Labels.PostRequest;

        export type PostResponse = HttpController.Labels.PostResponse;

    }
}

/**
 * @deprecated Use Chats.BOT_AGENT_FILTER_UID
 */
export const BOT_AGENT_FILTER_UID = Chats.BOT_AGENT_FILTER_UID;
